import type React from 'react'

type Props = {
  className?: string
  width?: number
  height?: number
}

export const FontSerif: React.FC<Props> = ({
  className,
  width = 26,
  height = 15,
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 26 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.811719 12.88H1.85172L6.37172 0.0399997H8.79172L13.3117 12.88H14.3517V14H8.97172V12.88H10.6917L9.55172 9.58H4.45172L3.35172 12.88H5.07172V14H0.811719V12.88ZM4.81172 8.42H9.21172L7.07172 2H6.97172L4.81172 8.42ZM18.6523 14.24C17.599 14.24 16.799 13.9867 16.2523 13.48C15.719 12.96 15.4523 12.2467 15.4523 11.34C15.4523 10.3267 15.819 9.56 16.5523 9.04C17.299 8.52 18.499 8.26 20.1523 8.26H21.5923V6.94C21.5923 6.14 21.4123 5.52667 21.0523 5.1C20.6923 4.67333 20.1257 4.46 19.3523 4.46C19.0457 4.46 18.7657 4.48667 18.5123 4.54C18.2723 4.59333 18.059 4.66 17.8723 4.74V4.82C18.019 4.88667 18.159 5 18.2923 5.16C18.439 5.32 18.5123 5.54667 18.5123 5.84C18.5123 6.24 18.3923 6.56 18.1523 6.8C17.9123 7.04 17.5923 7.16 17.1923 7.16C16.7923 7.16 16.4723 7.04 16.2323 6.8C15.9923 6.56 15.8723 6.24 15.8723 5.84C15.8723 5.52 15.959 5.21333 16.1323 4.92C16.319 4.62667 16.5857 4.36667 16.9323 4.14C17.2923 3.9 17.7323 3.71333 18.2523 3.58C18.7857 3.43333 19.399 3.36 20.0923 3.36C21.3723 3.36 22.339 3.66 22.9923 4.26C23.659 4.84667 23.9923 5.67333 23.9923 6.74V12.9H25.3723V13.84C25.1857 13.9467 24.9323 14.04 24.6123 14.12C24.3057 14.2 23.979 14.24 23.6323 14.24C22.9923 14.24 22.519 14.08 22.2123 13.76C21.919 13.4267 21.7723 13.0067 21.7723 12.5V12.46H21.6723C21.5657 12.6867 21.439 12.9067 21.2923 13.12C21.1457 13.32 20.9523 13.5067 20.7123 13.68C20.4857 13.8533 20.199 13.9867 19.8523 14.08C19.519 14.1867 19.119 14.24 18.6523 14.24ZM19.6123 12.78C20.1857 12.78 20.659 12.6467 21.0323 12.38C21.4057 12.1 21.5923 11.6533 21.5923 11.04V9.28H20.3923C19.4723 9.28 18.8257 9.43333 18.4523 9.74C18.079 10.0333 17.8923 10.4667 17.8923 11.04V11.4C17.8923 11.8667 18.0457 12.2133 18.3523 12.44C18.659 12.6667 19.079 12.78 19.6123 12.78Z"
        fill="#2F7FEF"
      />
    </svg>
  )
}
